import React from "react";
import { Card, Col, Row, Switch } from "antd";

const ForcedPopup = ({ widget, handleWidgetChange }) => {
  const handleStatusChange = (value) => {
    handleWidgetChange({ force_popup: value, id: widget.id });
  };

  return (
    <Card className="setting_wrapper">
      <Row className="">
        <Col span={18}>
          <h4>Forced Popup</h4>
        </Col>
        <Col span={6}>
          <div style={{ textAlign: "end" }}>
            <Switch
              id="custom-switch"
              name="force_popup"
              onChange={handleStatusChange}
              defaultChecked={widget?.force_popup}
              checked={widget?.force_popup}
            />
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default React.memo(ForcedPopup);
